module.exports = __webpack_public_path__ + "img/amazonses-logo.da6e8681.png";